
<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>

<div>
    <app-proyecto-educativo-contexto [simulacion]="simulacion" *ngIf="contexto"></app-proyecto-educativo-contexto>
    <app-proyecto-educativo-ideario [simulacion]="simulacion" *ngIf="ideario"></app-proyecto-educativo-ideario>
    <app-proyecto-educativo-objectivos [simulacion]="simulacion" *ngIf="objetivos"></app-proyecto-educativo-objectivos>
    <app-proyecto-educativo-evaluacion [simulacion]="simulacion" *ngIf="evaluacion"></app-proyecto-educativo-evaluacion>
</div>

<div *ngIf="!contexto && !ideario && !objetivos && !evaluacion">
    <div class="row">
        <a class="btn-guardar" *ngIf="showButtonDescargar" mat-raised-button (click)="imprimir()" style="padding-left: 15px;" >
            <i class="fas fa-print"></i> Descargar 
        </a>  
        <div class="btn-guardar" style="margin-left: 25px;color: #F5BB3F;background: #FFF;text-align: center;width: 250px;">
            <p class="statusname" *ngIf="status === 1">estado: No iniciado</p>
            <p class="statusname" *ngIf="status === 2">estado: Iniciado</p>
            <p class="statusname" *ngIf="status === 3">estado: Terminado</p>
        </div>
        <button class="btn-guardar" *ngIf="showButtonFinish && !simulacion" mat-raised-button  target="_blank" (click)="finalizarInforme()"
        style="padding-left: 15px;margin-left: 30px;" >
            <i class="far fa-check-circle"></i> Finalizar
        </button> 
    </div>

    <div class="customers">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-6">
                        <h2 class="titulo-card-naranja">Identificación</h2>
                    </div>

                    <div class="col-sm-6" style="text-align: right;">
                        <div class="green-check">
                            <i class="fas fa-check-circle"></i>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="project-edu">
                            <p>El Proyecto Educativo Institucional es un documento fundamental para la identidad y el quehacer de la unidad educativa. </p> <br>
                            <p>En este espacio encontrará un formato digital que facilitará su realización y que, además, le permitirá cumplir con lo recomendado por la institucionalidad vigente.</p>
                        </div>

                        <div class="identity-card">
                            <div class="card-body">
                                <div class="col-sm-12">
                                    <h4>Identificación de la Institución</h4>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Nombre:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.nombreInstitucion}}</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Sitio Web:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.sitioWebInstitucion}}</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Dirección:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.direccionInstitucion}}</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>





                    <div class="col-sm-6">
                        <div class="identity-card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <h4>Identificación de la Unidad Educativa</h4>
                                    </div>
                                </div>



                                <div class="row mt-2">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Nombre:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.nombreUnidadEducativa}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Código:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.codigoUnidadEducativa}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Directora / Encargada:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.directoraUnidadEducativa}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Correo electrónico:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.correoUnidadEducativa}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Teléfono:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.telefonoUnidadEducativa}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Dirección:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.direccionUnidadEducativa}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Comuna:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.comunaUnidadEducativa}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <p class="textPrincipalData">Región:</p>
                                    </div>

                                    <div class="col-sm-8">
                                        <p class="textSecondData">{{uniEducativaProyecto.regionUnidadEducativa}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                    <div class="col-sm-12">
                        <h2 class="titulo-card-naranja">Vigencia PEI</h2>
                    </div>

                    <div class="col-sm-12">
        

                        <div class="identity-card">
                            <div class="card-body">


                                <div class="row">
                                    <div class="col-2">
                                        <p class="textPrincipalData">Fecha Inicio:</p>
                                    </div>

                                    <div class="col-4">
                                         <div class="input-group p-2">
                                            <div class="input-group-append">
                                                <button class="btn btn-calendar" (click)="diI.toggle()" style="width: 40px;padding: 12px 12px;" type="button" >
                                                    <i class="fas fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                            
                                            <input class="form-control input-fecha" name="fechaInicio"  [(ngModel)]="this.fechaInicio" ngbDatepicker #diI="ngbDatepicker" readonly>

                                            <button class="btn btn-calendar-clear" type="button" (click)="clearDateinicio()" > 
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </div>


                                    <div class="col-2">
                                        <p class="textPrincipalData">Fecha Finalización:</p>
                                    </div>

                                    <div class="col-4">
                                         <div class="input-group p-2">
                                            <div class="input-group-append">
                                                <button class="btn btn-calendar" (click)="diT.toggle()" style="width: 40px;padding: 12px 12px;" type="button" >
                                                    <i class="fas fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                            
                                            <input class="form-control input-fecha" name="fechaTermino"  [(ngModel)]="this.fechaTermino" ngbDatepicker #diT="ngbDatepicker" readonly>

                                            <button class="btn btn-calendar-clear" type="button" (click)="clearDateTermino()" > 
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!--div class="row">
                                    <div class="col-sm-2">
                                        <p class="textPrincipalData">Año Inicial:</p>
                                    </div>

                                    <div class="col-4">

                                        <mat-form-field appearance="fill">
                                        <input matInput 
                                                type="text" 
                                                maxlength="4" 
                                                pattern="\d{4}" 
                                                (keypress)="soloNumeros($event)" 
                                                [(ngModel)]="this.fechaInicio"
                                                placeholder="Ingrese 4 dígitos" />
                                        </mat-form-field>
                                    </div>
                                </div-->


                                <div class="row">
                                    <div class="col-sm-12">
                                        <h4>Fechas de Actualización</h4>
                                    </div>
                                    <div class="col-2">
                                        <p class="textPrincipalData">Fecha Actualización Año 1:</p>
                                    </div>

                                    <div class="col-4">
                                         <div class="input-group p-2">
                                            <div class="input-group-append">
                                                <button class="btn btn-calendar" (click)="di1.toggle()" style="width: 40px;padding: 12px 12px;" type="button" >
                                                    <i class="fas fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                            
                                            <input class="form-control input-fecha" name="fecha1"  [(ngModel)]="this.fecha1" ngbDatepicker #di1="ngbDatepicker" readonly>

                                            <button class="btn btn-calendar-clear" type="button" (click)="clearDate1()" > 
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-2">
                                        <p class="textPrincipalData">Fecha Actualización Año 2:</p>
                                    </div>

                                   <div class="col-4">
                                         <div class="input-group p-2">
                                            <div class="input-group-append">
                                                <button class="btn btn-calendar" (click)="di2.toggle()" style="width: 40px;padding: 12px 12px;" type="button" >
                                                    <i class="fas fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                            
                                            <input class="form-control input-fecha" name="fecha2"  [(ngModel)]="this.fecha2" ngbDatepicker #di2="ngbDatepicker" readonly>

                                            <button class="btn btn-calendar-clear" type="button" (click)="clearDate2()" > 
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                  <div class="row">
                                    <div class="col-sm-2">
                                        <p class="textPrincipalData">Fecha Actualización Año 3:</p>
                                    </div>

                                   <div class="col-4">
                                         <div class="input-group p-2">
                                            <div class="input-group-append">
                                                <button class="btn btn-calendar" (click)="di3.toggle()" style="width: 40px;padding: 12px 12px;" type="button" >
                                                    <i class="fas fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                            
                                            <input class="form-control input-fecha" name="fecha3"  [(ngModel)]="this.fecha3" ngbDatepicker #di3="ngbDatepicker" readonly>

                                            <button class="btn btn-calendar-clear" type="button" (click)="clearDate3()" > 
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </div>

                                
                                </div>

                                <br/>
                                <div class="row">
                                    <div class="col-sm-12" style="text-align: right;">
                                    
                                            <button class="btn-guardar" mat-raised-button *ngIf="!simulacion"  (click)="guardarFechas()" >
                                                <i class="far fa-check-circle"></i> Modificar
                                            </button> 
                                    </div>
                                </div>




                            </div>
                        </div>

                    </div>























                </div>
            </div>
        </div>
    </div>


    <div class="recent-grid mt-3">

        <div class="projects">
            <div class="card">
                <div class="card-body" style="text-align: center;">
                    <div class="row">
                        <div class="col-sm-12" style="text-align: right;">
                            <div [ngClass]="{'green-check':completos1 === 5,'gris-check':completos1 === 0,'pink-check':(completos1 < 5 && completos1 > 0) }">
                                <i class="fas fa-check-circle"></i>
                            </div>
                        </div>
                    </div>
                    <h2>Contexto</h2>

                    <button type="button" class="btn btn-light btn-send" (click)="showContexto()"> ACCEDER</button>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-1">

                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos1 >= 1}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos1 >= 2}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos1 >= 3}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos1 >= 4}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos1 >= 5}">

                            </div>
                        </div>
                        <div class="col-sm-1">

                        </div>
                    </div>
                    <div class="row">
                        <p style="margin: 25px 0px;font: normal normal bold 10px/13px Montserrat;letter-spacing: 0px; color: #252C40; text-transform: uppercase; opacity: 1;">{{completos1}} de 5 SECCIONES</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="projects">
            <div class="card">
                <div class="card-body" style="text-align: center;">
                    <div class="row">
                        <div class="col-sm-12" style="text-align: right;">
                            <div [ngClass]="{'green-check':completos2 === 6,'gris-check':completos2 === 0,'pink-check':(completos2 < 6 && completos2 > 0) }">
                                <i class="fas fa-check-circle"></i>
                            </div>
                        </div>
                    </div>
                    <h2>Ideario</h2>

                    <button type="button" class="btn btn-light btn-send" (click)="showIdeario()"> ACCEDER</button>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos2 >= 1}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos2 >= 2}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos2 >= 3}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos2 >= 4}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos2 >= 5}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos2 >= 6}">

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <p style="margin: 25px 0px;font: normal normal bold 10px/13px Montserrat;letter-spacing: 0px; color: #252C40; text-transform: uppercase; opacity: 1;">{{completos2}} de 6 SECCIONES</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="projects">
            <div class="card">
                <div class="card-body" style="text-align: center;">
                    <div class="row">
                        <div class="col-sm-12" style="text-align: right;">
                            <div [ngClass]="{'green-check':completos3 === 2,'gris-check':completos3 === 0,'pink-check':(completos3 < 2 && completos3 > 0) }">
                                <i class="fas fa-check-circle"></i>
                            </div>
                        </div>
                    </div>
                    <h2>Objetivos</h2>

                    <button type="button" class="btn btn-light btn-send" (click)="showObjetivos()"> ACCEDER</button>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-4">

                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos3 >= 1}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos3 >= 2}">

                            </div>
                        </div>
                        <div class="col-sm-4">

                        </div>
                    </div>
                    <div class="row">
                        <p style="margin: 25px 0px;font: normal normal bold 10px/13px Montserrat;letter-spacing: 0px; color: #252C40; text-transform: uppercase; opacity: 1;">{{completos3}} de 2 SECCIONES</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="projects">
            <div class="card">
                <div class="card-body" style="text-align: center;">
                    <div class="row">
                        <div class="col-sm-12" style="text-align: right;">
                            <div [ngClass]="{'green-check':completos4 === 2,'gris-check':completos4 === 0,'pink-check':(completos4 < 2 && completos4 > 0) }">
                                <i class="fas fa-check-circle"></i>
                            </div>
                        </div>
                    </div>
                    <h2>Evaluación</h2>

                    <button type="button" class="btn btn-light btn-send" (click)="showEvaluacion()"> ACCEDER</button>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-4">

                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos4 >= 1}">

                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="circle" [ngClass]="{'circle-green':completos4 >= 2}">

                            </div>
                        </div>
                        <div class="col-sm-4">

                        </div>
                    </div>
                    <div class="row">
                        <p style="margin: 25px 0px;font: normal normal bold 10px/13px Montserrat;letter-spacing: 0px; color: #252C40; text-transform: uppercase; opacity: 1;">{{completos4}} de 2 SECCIONES</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>



<ng-template #modalInforme let-modal class="modal-dialog modal-xl">
    <div class="modal-header" style="padding: 0px " width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Proyecto Educativo Institucional</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px;" width="100%">
        <iframe [src]="urlSafe" frameborder="0" width="100%" style="min-height: 700px;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
    </div>
</ng-template>